import { makeAutoObservable } from 'mobx'
import { getUrlParam } from '@/utils'


class common28Store {
  utoken = ''
  constructor() {
    makeAutoObservable(this)
  }

  // 获取数据
  setUtoken = () => {
    this.utoken = getUrlParam('authKey') || localStorage.getItem('txhAuthKey')
  }
}

export default common28Store